var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { faEnvelope } from "@fortawesome/pro-regular-svg-icons";
import { faSearch, faTimes } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TableView } from "@yodlee/common-components";
import { Button, Col, Icon, Input, Row, Tooltip } from "antd";
import { get } from "lodash";
import React from 'react';
import Highlighter from "react-highlight-words";
import InfiniteScroll from "react-infinite-scroll-component";
var EmailListView = /** @class */ (function (_super) {
    __extends(EmailListView, _super);
    function EmailListView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            searchFilterKeys: {},
            pageNumber: 50
        };
        _this.searchFilterRefs = {};
        _this.handleSearch = function (selectedKeys, confirm, key) {
            var _a;
            var searchFilterKeys = _this.state.searchFilterKeys;
            confirm();
            _this.setState({
                searchFilterKeys: __assign(__assign({}, searchFilterKeys), (_a = {}, _a[key] = selectedKeys[0], _a)),
            });
        };
        _this.handleReset = function (clearFilters, key) {
            var _a;
            var searchFilterKeys = _this.state.searchFilterKeys;
            clearFilters();
            _this.setState({
                searchFilterKeys: __assign(__assign({}, searchFilterKeys), (_a = {}, _a[key] = undefined, _a)),
            });
        };
        _this.searchFilterProps = function (dataIndex, title, key, getValue) {
            if (getValue === void 0) { getValue = function (item) { return (item || "").toString(); }; }
            return ({
                filterDropdown: function (_a) {
                    var setSelectedKeys = _a.setSelectedKeys, selectedKeys = _a.selectedKeys, confirm = _a.confirm, clearFilters = _a.clearFilters;
                    return (React.createElement("div", { className: "padding-xs" },
                        React.createElement(Input, { className: "no-margin no-padding", ref: function (node) {
                                _this.searchFilterRefs[key] = node;
                            }, placeholder: "Search by ".concat(title.toLowerCase()), value: selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys[0], onChange: function (e) {
                                var value = e.target.value;
                                setSelectedKeys(value ? [e.target.value] : []);
                                !value && _this.handleReset(clearFilters, key);
                            }, onPressEnter: function () { return _this.handleSearch(selectedKeys, confirm, key); }, style: { width: 188, marginBottom: 8, display: 'block' }, allowClear: true })));
                },
                filterIcon: React.createElement(Icon, { component: function () { return React.createElement(FontAwesomeIcon, { icon: faSearch }); } }),
                onFilter: function (value, record) {
                    var newValue = get(record, dataIndex, "");
                    if (getValue) {
                        newValue = getValue(newValue);
                    }
                    return newValue.toString().toLowerCase().includes(value.toLowerCase());
                },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () { return _this.searchFilterRefs[key].select(); });
                    }
                },
                onClearFilter: function () { return _this.handleReset(function () { }, key); },
                render: function (text) {
                    var wordsToHighLight = undefined, currentFilter = _this.state.searchFilterKeys[key];
                    if (currentFilter)
                        wordsToHighLight = Array.isArray(currentFilter) ? currentFilter : [currentFilter];
                    return text && wordsToHighLight ?
                        React.createElement(Highlighter, { highlightStyle: { backgroundColor: 'yellow', padding: 0 }, searchWords: wordsToHighLight, autoEscape: true, textToHighlight: getValue(text) }) :
                        React.createElement(Tooltip, { title: getValue(text), placement: "bottomLeft" }, getValue(text));
                }
            });
        };
        _this.render = function () {
            var pageNumber = _this.state.pageNumber;
            var _a = _this.props, emails = _a.emails, onClose = _a.onClose;
            // Convert emails array to table data format
            var emailData = emails.map(function (email, index) { return ({
                index: index,
                email: email
            }); });
            return (React.createElement(React.Fragment, null,
                React.createElement(Row, { className: "padding-md-horizontal" },
                    React.createElement(Col, { span: 20 },
                        React.createElement(Icon, { component: function () { return React.createElement(FontAwesomeIcon, { icon: faEnvelope }); } }),
                        " Emails notified"),
                    React.createElement(Col, { span: 4, className: "align-right" },
                        React.createElement(Icon, { onClick: onClose, className: "color-gray-5", component: function () { return React.createElement(FontAwesomeIcon, { icon: faTimes }); } }))),
                React.createElement("div", { style: { height: "82vh", overflow: "scroll" }, id: "scrollableDivEmails" },
                    React.createElement(InfiniteScroll, { dataLength: pageNumber, next: function () {
                            if (pageNumber > emailData.length) {
                                _this.setState({ pageNumber: pageNumber + 50 });
                            }
                            else {
                                _this.setState({ pageNumber: pageNumber + 50 });
                            }
                            return;
                        }, hasMore: pageNumber < emailData.length, scrollableTarget: "scrollableDivEmails", loader: React.createElement("span", null) },
                        React.createElement("span", { className: "hide-pagination only-header-border" },
                            React.createElement(TableView, { tableSetting: false, getRowKey: function (data) { return "".concat(data.index, "_").concat(data.email).toString(); }, data: emailData, rowDensity: "small", pagination: { pageSize: pageNumber }, columns: [
                                    __assign({ title: "Email", key: "email", dataIndex: "email", minWidth: 200, sorter: function (a, b) {
                                            var firstEmail = (a.email || "").toLowerCase();
                                            var secondEmail = (b.email || "").toLowerCase();
                                            return firstEmail === secondEmail ? 0 : secondEmail > firstEmail ? -1 : 1;
                                        } }, _this.searchFilterProps("email", "Email", "email"))
                                ] })))),
                React.createElement("div", { className: "background-gray-1 align-right padding-lg border-top" },
                    React.createElement(Button, { type: "primary", onClick: onClose }, "Close"))));
        };
        return _this;
    }
    return EmailListView;
}(React.Component));
export default EmailListView;
//# sourceMappingURL=email-list-view.js.map